module.exports = __webpack_public_path__ + "img/carshina22_12.947cdf70.jpg";